function scrollSpy() {
	$('.js-spy-section').each(function() {
		const $this = $(this);
		const windowHeight = $(window).outerHeight() / 2;
		const sectOuter = $this.outerHeight() / 2;
		const sectOffset = $this.offset().top - sectOuter;
		const currentClass = 'current';

		if (sectOffset <= $(window).scrollTop()) {
			let id = $this.attr('id');

			$('.js-spy-nav li').removeClass(currentClass);

			$('.js-spy-nav')
				.find('a[href="#' + id + '"]')
				.closest('li')
				.addClass(currentClass);

			if (sectOffset == 0) {
				$('.js-spy-nav li').removeClass(currentClass);
			}
		}
	});
}

module.exports = { scrollSpy };
